export default "__VITE_ASSET__ByF_qy6T__"